import { gql } from "@/apis/nannyml";

export const getTags = gql(/* GraphQL */ `
  query GetTags {
    tags {
      name
    }
  }
`);
